import * as React from "react";
import { Button, Card, CardBody } from "reactstrap";

export type FenceSegmentCardIncompleteProps = {
  fenceSegmentId: string;
  handleDeleteStyle: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleAddFenceStyle: (e: React.MouseEvent<HTMLButtonElement>) => void;
  fenceLinearFeet: number;
};

export function FenceSegmentCardIncomplete(props: FenceSegmentCardIncompleteProps) {
  return (
    <Card className="border border-warning border-2 mb-2" style={{ background: "rgba(232,160,32,0.07)" }}>
      <CardBody className="py-2">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            <span className="badge bg-warning text-dark text-uppercase mb-1" style={{ fontSize: "10px", letterSpacing: "0.5px" }}>
              Incomplete
            </span>
            <div className="small fw-bold text-primary">{props.fenceLinearFeet} LFT · Style needed</div>
          </div>
          <Button
            color="danger"
            size="sm"
            outline
            onClick={props.handleDeleteStyle}
            value={props.fenceSegmentId}
          >
            ✕
          </Button>
        </div>
        <Button
          color="warning"
          size="sm"
          className="w-100 text-dark fw-bold"
          onClick={props.handleAddFenceStyle}
          value={props.fenceSegmentId}
        >
          + Add Style
        </Button>
      </CardBody>
    </Card>
  );
}
